import classNames from 'classnames'
import React from 'react'

import styles from './ExpandableContainer.module.scss'

const ExpandableContainer = (props) => {
  const { id, isOpen, classes, arrowPosition, children } = props

  const classStyles = classNames(
    styles.expandable,
    styles[arrowPosition],
    classes
  )

  const contentClasses = classNames(
    styles.content,
    { [styles.isClosed]: !isOpen },
    { [styles.isOpen]: isOpen }
  )

  return (
    <div id={id} className={classStyles} data-cy="expandableContainer">
      <div className={contentClasses}>{children}</div>
    </div>
  )
}

ExpandableContainer.defaultProps = {
  isOpen: false,
  arrowPosition: 'left'
}

export default ExpandableContainer
